import React from "react";
import Link from "next/link";

export default function TopBar() {
  return (
    <div className=" absolute left-0 top-0 w-full flex items-center z-10 ">
      <div className=" flex flex-1 items-center ">
        <Link href="/">
          <img
            src="/images/Logo-white.png"
            className="h-16 cursor-pointer relative left-1 top-1 lg:left-3 lg:top-2"
            alt="Snacktime"
          />
        </Link>
      </div>
    </div>
  );
}
